// extracted by mini-css-extract-plugin
module.exports = {"Portfolio":"Portfolio_Portfolio__24C6R"};